import React, { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import { usePermission } from '@tomfxs/permissions-client'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import RouteContainer from 'src/components/App/RouteContainer'

const WorkflowUpdateForm = React.lazy(() => loadComponent('traiwiss', 'WorkflowUpdateForm'))

export function WorkflowUpdateRoute() {
    const params = useParams()
    const navigate = useNavigate()

    const { academy } = useFlightDeck()

    const canUpdate = usePermission('traiwiss.workflow.update', { academy: academy?._id! })
    const canDelete = usePermission('traiwiss.workflow.delete', { academy: academy?._id! })

    const onDelete = useCallback(() => {
        navigate('/workflows')
    }, [navigate])

    const onUpdate = useCallback(() => {
        navigate('/workflows')
    }, [navigate])

    return (
        <RouteContainer>
            <WorkflowUpdateForm _id={params._id} canDelete={canDelete} canUpdate={canUpdate} onDelete={onDelete} onUpdate={onUpdate} />
        </RouteContainer>
    )
}
